import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';

interface Props { 
    icon: React.ReactNode; 
    iconColor?: string; 
    title: string; 
    handler?: any; 
    data?: any; 
    isDisabled?: boolean; 
}; 

const DataRow: React.FC<Props> = ({ icon, iconColor, title, handler, data, isDisabled }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 

    return (

        <Box
            onClick={handler}
            sx={{ 
                display: 'flex',
                flexDirection: 'row', 
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: 1, 
                width: '95%',
                minHeight: 30, 
                padding: 1, 
                fontSize: 14, 
                borderBottomWidth: 0.5, 
                borderBottomColor: 'rgba(41, 118, 255, 0.1)', 
                borderBottomStyle: 'solid', 
                '&:hover': { backgroundColor: isDisabled ? 'transparent' : colors?.sectionHover }
            }}
        >
            <Box
                sx={{ 
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    color: iconColor ? iconColor : colors?.main, 
                }}
            >

                {icon}

                <Box sx={{ marginLeft: 1, color: colors?.text }}>{t(title)}</Box>

            </Box>

            <Box
                sx={{ 
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    fontWeight: 'bold'
                }}
            >

                {data ? data : 0}

            </Box>

        </Box>

  );

};

export default DataRow;